import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function NotFound() {
  return (
    <Box textAlign="center" py={8}>
      <Typography variant="h3" gutterBottom>404</Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Oops! Page not found.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        Go Home
      </Button>
    </Box>
  );
}
